import type { CastMediaStatusInterceptor } from '@dicetechnology/doris-plugin-chromecast-receiver';

import { applyLiveSeekableRangePatch } from './applyLiveSeekableRangePatch';
import { applySubtitlePolicyPatch } from './applySubtitlePolicyPatch';
import { removeResolvedSourceFromCustomData } from './removeResolvedSourceFromCustomData';

export const mediaStatusInterceptor: CastMediaStatusInterceptor = async (mediaStatus) => {
    mediaStatus = applyLiveSeekableRangePatch(mediaStatus);
    mediaStatus = applySubtitlePolicyPatch(mediaStatus);
    mediaStatus = removeResolvedSourceFromCustomData(mediaStatus);

    return mediaStatus;
};
